/**
 * B10：投后组合仪表盘（p8d）交互 — 从 legacy-app.js 拆出。
 */
import { escapeHtml } from '../util/html.js';

/** @param {import('./portal-ui-deps.js').PortalUiDeps} deps */
export function initPostInvestmentDashboardUi(deps) {
  const { requestRuntime, showRuntimeError, getCurrentProjectId } = deps;

  function renderPortfolioDashboard(dashboard) {
    document.getElementById('portfolio-total').textContent =
      String(dashboard.totalPostInvestment ?? 0);
    document.getElementById('portfolio-alerts').textContent =
      String(dashboard.withActiveAlerts ?? 0);
    document.getElementById('portfolio-kpi-fresh').textContent =
      String(dashboard.kpiFreshCount ?? 0);
    document.getElementById('portfolio-revenue').textContent =
      String(dashboard.aggregateRevenue ?? 0);
    document.getElementById('portfolio-project-list').innerHTML =
      (dashboard.projects || []).map((row) => `
      <div style="padding:8px 10px;margin-bottom:6px;border:1px solid #E8E4DC;border-radius:4px;background:#FCFAF5;">
        <strong>${escapeHtml(row.projectName)}</strong>
        <span style="color:#6B7280;"> · ${escapeHtml(row.companyName || '—')}</span>
        <div style="margin-top:4px;color:#6B7280;">
          收入 ${row.revenue ?? '—'} 万 · 风险 ${escapeHtml(row.overallRiskLevel || '—')}
          · KPI ${escapeHtml(row.kpiCollectedAt ? row.kpiCollectedAt.slice(0, 10) : '未采集')}
        </div>
      </div>
    `).join('') || '<div>暂无投后项目</div>';
    document.getElementById('portfolio-disclaimer').textContent =
      dashboard.disclaimer || '';
  }

  document.getElementById('portfolio-refresh-btn')?.addEventListener('click', async function () {
    const originalText = this.textContent;
    this.disabled = true;
    this.textContent = '加载中...';
    try {
      const result = await requestRuntime('/api/business/post-investment/portfolio');
      renderPortfolioDashboard(result.dashboard || result);
      document.getElementById('stage-result-p8d').textContent =
        `组合仪表盘已更新 · ${new Date().toLocaleString()}`;
    } catch (error) {
      showRuntimeError(error.message);
    } finally {
      this.disabled = false;
      this.textContent = originalText;
    }
  });

  document.getElementById('portfolio-kpi-collect-btn')?.addEventListener('click', async function () {
    const projectId = getCurrentProjectId();
    if (!projectId || projectId === 'draft') {
      showRuntimeError('请先打开或创建项目');
      return;
    }
    const originalText = this.textContent;
    this.disabled = true;
    this.textContent = '采集中...';
    try {
      const result = await requestRuntime('/api/business/post-investment/kpi/collect', {
        method: 'POST',
        body: JSON.stringify({ projectId, deriveFromContext: true }),
      });
      document.getElementById('stage-result-p8d').textContent =
        `KPI 已采集：${result.snapshot?.summary || result.recordId || ''}`;
    } catch (error) {
      showRuntimeError(error.message);
    } finally {
      this.disabled = false;
      this.textContent = originalText;
    }
  });
}
